import { makeAutoObservable, observable, runInAction } from 'mobx'

import { NotificationApi } from '../api'
import { type Notification } from '../types'
import { filterRecentNotifications } from '../utils/NotificationUtils'

import { GlobalStore } from './GlobalStore'

export class NotificationStore {
  globalStore: GlobalStore
  api = new NotificationApi('/', '')

  isLoading: boolean = true
  notifications: Notification[] = []
  notificationsLoaded: boolean = false

  constructor(globalStore: GlobalStore) {
    this.globalStore = globalStore
    this.api = new NotificationApi(
      globalStore.endpoint,
      globalStore.sessionToken,
      globalStore.onError,
    )

    makeAutoObservable(this, { notifications: observable })
  }

  // Used in Money Dashboard
  get newNotifications(): Notification[] {
    return this.recentNotifications.filter((n) => !n.has_been_viewed)
  }

  get recentNotifications(): Notification[] {
    return filterRecentNotifications(this.notifications)
  }

  setNotifications = (notifications: Notification[]) => {
    this.notifications = notifications
    this.notificationsLoaded = true
  }

  loadNotifications = async () => {
    this.isLoading = true
    try {
      const notifications = await this.api.getNotifications()
      this.setNotifications(notifications)
    } catch (error) {
      console.error('Error occurred while loading notifications:', error)
      this.globalStore.captureException(error, { store: 'NotificationStore' })
    } finally {
      runInAction(() => {
        this.isLoading = false
      })
    }
  }

  markAllAsViewed = async () => {
    // Update on the server
    await this.api.markAllAsViewed()
  }

  updateNotification = async (notification: Notification) => {
    notification.has_been_viewed = true
    await this.api.updateNotification(notification)
  }
}
